import { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { HistoricoEstadoEquipoService } from "../../../services/auxiliar/HistoricoEstadoEquipo";
import { IComboOperadores } from "../../../Interfaces/estadoEquipos/IEstadoEquipo";

interface UOperador {
    isOpen: boolean;
    equipoId?: string
}

export const useOperador = (props: UOperador) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filterOperador, setFilterOperador] = useState<IComboOperadores>({
        skip: 0,
        take: 20,
        search: "",
        equipoId: props.equipoId || "",
    });
    const [dataComboOperadores, setDataComboOperador] = useState<IComboBoxOption[]>([]);
    const comboBoxRefOperador = useRef<IComboBox>(null);
    const onClickComboEquipo = () => comboBoxRefOperador.current?.focus(true);

    const onChangeOperador = (value: any) => {
        setFilterOperador({ ...filterOperador, search: value });
    }
    // const _openOption = useCallback(
    //     () => comboBoxRefOperador.current?.focus(true),
    //     []
    // );
    const _onkeyUpSearchOperador = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefOperador.current?.focus(false);
            setFilterOperador({
                skip: 0,
                take: 20,
                search: "",
                equipoId: "",
            });
        } else {
            // _openOption();
            let { value } = event?.target as HTMLInputElement;
            setFilterOperador({ ...filterOperador, search: value });
        }
    };

    const listarComboOperadores = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        HistoricoEstadoEquipoService.ComboOperadores(filterOperador, newController).then((res) => {
            if (res.status === 200) {
                setDataComboOperador(res.data);
            }
        });
    };

    useEffect(() => {
        if (filterOperador.search != "") {
            listarComboOperadores()
        }
    }, [filterOperador.search])

    useEffect(() => {
        if (props.isOpen) {
            listarComboOperadores();
        }
    }, [props.isOpen]);

    return {
        dataComboOperadores,
        onClickComboEquipo,
        _onkeyUpSearchOperador,
        comboBoxRefOperador,
        setFilterOperador,
        filterOperador,
        onChangeOperador
    };
}

